import { DrawCabinetInsideElement } from './DrawCabinetInsideElement';

export class DrawInsideLiftingColumn extends DrawCabinetInsideElement {
    Number!: number;
}
